import { Stack } from '@mui/material'
import { SxProps } from '@mui/material'
import { CSSProperties, forwardRef, ReactNode } from 'react'

export const SortableItem = forwardRef<
  HTMLDivElement,
  {
    children: ReactNode
    withOpacity?: boolean
    isDragging?: boolean
    style?: CSSProperties
    sx?: SxProps
  }
>(({ children, withOpacity, isDragging, style, sx }, ref) => {
  const inlineStyles: CSSProperties = {
    opacity: withOpacity ? '0.9' : '1',
    transformOrigin: '50% 50%',
    cursor: isDragging ? 'grabbing' : 'grab',
    boxShadow: isDragging
      ? 'rgb(63 63 68 / 5%) 0px 2px 0px 2px, rgb(34 33 81 / 15%) 0px 2px 3px 2px'
      : 'rgb(63 63 68 / 5%) 0px 0px 0px 1px, rgb(34 33 81 / 15%) 0px 1px 3px 0px',
    transform: isDragging ? 'scale(1.05)' : 'scale(1)',
    ...style,
  }
  return (
    <Stack ref={ref} sx={{ ...inlineStyles, ...sx }}>
      {children}
    </Stack>
  )
})
SortableItem.displayName = 'SortableItem'
